
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"24","height":"24","rx":"12","fill":"#E25050"}}),_c('path',{attrs:{"d":"M12 15.448c-.671 0-1.233.562-1.233 1.233s.562 1.233 1.233 1.233c.646 0 1.233-.562 1.204-1.203A1.204 1.204 0 0012 15.448zM11.693 6.79c-.587.167-.952.7-.952 1.346.03.39.055.785.084 1.174l.252 4.426c.03.503.419.868.922.868.503 0 .898-.39.923-.898 0-.306 0-.587.03-.898.054-.952.113-1.904.167-2.856.03-.617.084-1.234.114-1.85 0-.222-.03-.42-.114-.617a1.237 1.237 0 00-1.426-.696z","fill":"#fff"}})])
          )
        }
      }
    